import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import Cookies from "vue-cookies";


const routes = [
	{
		path: "/",
		name: "/",
		component: () => import("../components/signin.vue"),
		meta: { requiresAuth: false },
	},
	{
		path: "/home",
		name: "Home",
		component: () => import("../components/index.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/patients",
		name: "PatientsDashboard",
		component: () => import("../components/patients/PatientsDashboard.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/patientbillspage",
		name: "patientbillspage",
		component: () => import("../components/finance/patientbillspage.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/patients/:id",
		name: "PatientProfile",
		component: () => import("../components/patients/PatientProfile.vue"),
		props: true,
		meta: { requiresAuth: true },
	},

	{
		path: "/appointments",
		name: "AppointmentsDashboard",
		component: () => import("../components/AppointmentsDashboard.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/appointments/:patientId",
		name: "AppointmentsDashboardWithPatient",
		component: () => import("../components/AppointmentsDashboard.vue"),
		props: true,
		meta: { requiresAuth: true },
	},

	{
		path: "/opd",
		name: "OPDDashboard",
		component: () => import("../components/OPD.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/ipd",
		name: "IPDDashboard",
		component: () => import("../components/IPD.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/organization/staff",
		name: "organization_staff",
		component: () =>
			import("../components/organization/OrganizationStaff.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/organization/departments",
		name: "organization_departments",
		component: () =>
			import("../components/organization/OrganizationDepartments.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/staff/:id",
		name: "StaffDetails",
		component: () => import("@/components/StaffDetails.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/financepage",
		name: "FinancePage",
		component: () => import("../components/finance/FinancePage.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/services/dashboard",
		name: "ServicesDashboard",
		component: () => import("../components/medical_services/dashboard.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/services/laboratory",
		name: "LaboratoryServices",
		component: () =>
			import("../components/medical_services/LaboratoryServices.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/services/radiology",
		name: "RadiologyServices",
		component: () =>
			import("../components/medical_services/RadiologyServices.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/services/categories",
		name: "ServiceCategories",
		component: () =>
			import("../components/medical_services/ServiceCategories.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/settings",
		name: "Settings",
		component: () => import("../components/settings/users.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/settingroles",
		name: "Settingsroles",
		component: () => import("../components/settings/roles.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/queue",
		name: "PatientsQueue",
		component: () => import("../components/pharmacy/PatientsQueue.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/prescription/:id",
		name: "PrescriptionPage",
		component: () => import("../components/pharmacy/PrescriptionPage.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/medicines",
		name: "PharmacyMedicines",
		component: () => import("../components/pharmacy/Medicines.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/requisition",
		name: "PharmacyRequisition",
		component: () => import("../components/pharmacy/requisition.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/requisition/add",
		name: "AddPharmacyRequisition",
		component: () => import("../components/pharmacy/newRequisition.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/pharmacy/receive/:id",
		name: "ReceivePharmacyItems",
		component: () => import("../components/pharmacy/receiveItems.vue"),
		meta: { requiresAuth: true },
	},

	{
		path: "/inventory/issue/:id",
		name: "IssuePharmacyItems",
		component: () => import("../components/inventory/IssuingPage.vue"),
		meta: { requiresAuth: true },
	},

	// {
	//   path: "/patients/:id",
	//   component: () => import("../components/patients/PatientProfile.vue"),
	//   meta: { requiresAuth: true, props: true },
	// },

	// INVENTORY
	{
		path: "/inventory/dashboard",
		name: "Inventory",
		component: () => import("../components/inventory/dashboard.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/items",
		name: "Items",
		component: () => import("../components/inventory/items.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/vendors",
		name: "Vendors",
		component: () => import("../components/inventory/vendors.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/bills",
		name: "Bills",
		component: () => import("../components/inventory/bills.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/adjustment",
		name: "Adjustment",
		component: () => import("../components/inventory/adjustment.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/requisition",
		name: "Requisition",
		component: () => import("../components/inventory/requisition.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/requisition/add",
		name: "AddRequisition",
		component: () => import("../components/inventory/newRequisition.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/po",
		name: "PurchaseOrders",
		component: () => import("../components/inventory/purchase_orders.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/newPO/:id",
		name: "NewPO",
		component: () => import("../components/inventory/newPurchaseOrder.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/assets",
		name: "AssetManagement",
		component: () => import("../components/inventory/assetManagement.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/assets/info/:id",
		name: "AssetInfo",
		component: () => import("../components/inventory/AssetInfo.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/receive/:id",
		name: "ReceiveItems",
		component: () => import("../components/inventory/receiveItems.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/payment/request",
		name: "PaymentRequest",
		component: () => import("../components/inventory/requestPayment.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/items/issue",
		name: "IssueItems",
		component: () => import("../components/inventory/issueItems.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/inventory/items/return",
		name: "ReturnItems",
		component: () => import("../components/inventory/returnItems.vue"),
		meta: { requiresAuth: true },
	},
	
	{
		path: "/services/dashboard",
		name: "ServicesDashboard",
		component: () => import("../components/medical_services/dashboard.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/services/laboratory",
		name: "Laboratory",
		component: () =>
			import("../components/medical_services/LaboratoryServices.vue"),
		meta: { requiresAuth: true },
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,

	scrollBehavior(to, from, savedPosition) {
		// If there is a saved position (e.g., user clicked the back button), return it
		if (savedPosition) {
			return savedPosition;
		}

		// If the route has a hash, try to scroll to the element with that ID
		if (to.hash) {
			const element = document.querySelector(to.hash);
			if (element) {
				return {
					el: to.hash,
					behavior: "smooth",
				};
			}
			// If the element doesn't exist, scroll to the top
			return { top: 0 };
		}

		// Default behavior: try to scroll to the #sidenavmain element
		const sidenavMain = document.getElementById("sidenavmain");
		if (sidenavMain) {
			return {
				el: "#sidenavmain",
				behavior: "smooth",
			};
		}

		// Fallback: scroll to the top of the page if #sidenavmain doesn't exist
		return { top: 0 };
	},
});

router.beforeEach((to, from, next) => {
	const publicPages = ["/"];
	const authRequired = !publicPages.includes(to.path);
	const isAuthenticated =
		store.getters.isAuthenticated || localStorage.getItem("authToken");

	let modalBackground = document.querySelector(".modal-backdrop");
	if (modalBackground) {
		modalBackground.remove();
	}

	if (authRequired && !isAuthenticated) {
		next("/");
	} else {
		const requiredRoles = to.meta.requiresRoles;

		if (requiredRoles && to.path !== "/home") {
			const userRoles = Cookies.get("userRoles");
			const hasRequiredRole = userRoles.some((userRole) =>
				requiredRoles.includes(userRole)
			);
			if (hasRequiredRole) {
				next();
			} else {
				window.$("#myModalaccessdenied").modal("show");
			}
		} else {
			next();
		}
	}
});

export default router;
